import { ValidatorFn, AbstractControl } from "@angular/forms";

export const CURRENCIES = ['TRY', 'USD', 'EUR'];
export const PROVIDER_TYPES = ['FlightProvider', 'HotelProvider', 'PackageProvider', 'ChannelManagerProvider', 'RentingProvider', 'AutocompleteProvider'];
export const FLIGHT_PROVIDERS = ['tourvisio'];
export const PACKAGE_PROVIDERS = ['bizipackage', 'traveltek'];
export const AGENCY_ADD_PACKAGE_PROVIDERS = ['bizipackage'];
export const CRUISE_SEGMENT = 'CRUISE';
export const TRAVELTEK_LINE_IDS = /^\d+(,\d+)*$/;
export const HOTEL_PROVIDERS = ['tourvisioHotel','bizihotel'];
export const CHANNEL_MANAGER_PROVIDERS = ['paximum'];
export const KVKK_PROVIDERS = ['dijiizin'];
export const RENTING_PROVIDERS = ['tourvisioRenting'];
export const AUTOCOMPLETE_PROVIDERS = ['tourvisioAutocomplete'];
export const TV_PROVIDERS = ['tourvisio', 'tourvisioHotel', 'tourvisioRenting', 'tourvisioAutocomplete'];
export const RENTING_OFFER_TYPES = ['FullCredit', 'PartialCredit'];
export const PROVIDER_FIELDS = {
  FlightProvider: {
    tourvisio: ['baseURL'],
  },
  HotelProvider: {
    tourvisioHotel: ['baseURL'],
    bizihotel: ['baseURL', 'ShowUseCompanyPrice'],

  },
  PackageProvider: {
    bizipackage: ['baseURL'],
    traveltek: ['username', 'password', 'sid', 'tradingNameId', 'importTarget', 'defaultLineIds']
  },
  ChannelManagerProvider: {
    paximum: ['baseURL', 'appToken']
  },
  RentingProvider: {
    tourvisioRenting: ['baseURL'],
  },
  AutocompleteProvider: {
    tourvisioAutocomplete: ['baseURL']
  }
};
export const ORGANIZATION_STATUSES = ['Active', 'Pending', 'Error','Inactive'];
export const PAYMENT_GATEWAYS = ['ziraat','isbank'];
export const CC_3D_STORETYPES = ['3d','3d_pay','3d_pay_hosting'];

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): {  [key: string]: any  } => {
    if(!control.value) {
      return null;
    }

    let reg = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*\\-\\_,;.:~<>+`?£|=\\/])(?=.{8,})');
    if(!reg.test(control.value)) {
      return {
        isPasswordValid: {
          isPasswordValid: false
        }
      }
    }
    return null;
  }
}

export const RESTRICTION_PARAMETERS = {
  type: 'Restriction',
  context: {
    hotelSearch: 'HotelSearch',
    secondBillingAddress: 'SecondBillingAddress',
    integrationReportPurchaseRow: 'IntegrationReportPurchaseRow',
    searchPriority: 'SearchPriority',
    mailOrder: 'MailOrder',
    tourvisioRentingAgency: 'TourvisioRentingAgency',
    showSharedWithPaximum: 'ShowSharedWithPaximum'
  },
  keys: {
    hotelSearch: {
      currency: 'Currency',
      day: 'Day',
      country: 'Country'
    },
    secondBillingAddress: 'ShowSecondBillingAddress',
    integrationReportPurchaseRow: 'ShowIntegrationReportPurchaseRow',
    searchPriority: 'MaximumSelect',
    mailOrder: 'IsMailOrderActive',
    tourvisioRentingAgency: {
      restrictedOfferTypes: 'RestrictedOfferTypes'
    },
    showSharedWithPaximum: 'ShowSharedWithPaximum'
  },
  values: {
    secondBillingAddress: {
      active: '1',
      passive: '0'
    },
    integrationReportPurchaseRow: {
      active: '1',
      passive: '0'
    },
    mailOrder: {
      active: '1',
      passive: '0'
    },
    showSharedWithPaximum: {
      active: '1',
      passive: '0'
    }
  }
}

export const TVPROVIDER_PARAMETERS = {
  type: 'TourvisioProvider',
  context: {
    login: 'tv_login',
    operator: 'tv_operator',
    token: 'tv_token'
  },
  keys: {
    login: {
      applicationToken: 'tv_applicationToken',
      serviceUrl: 'tv_serviceUrl',
      agency: 'tv_agency',
      user: 'tv_username',
      password: 'tv_password',
    },
    token: {
      token: 'tv_token',
      expiresOn: 'tv_expiresOn'
    },
    operator: {
      isPaximumTourvisio: 'tv_paximum'
    }
  }
};



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/constants/constants.ts